import React, { useState } from 'react';
import { Modal, Form, Button, Alert, ProgressBar } from 'react-bootstrap';
import { FaUpload } from 'react-icons/fa';
import { resourceService } from '../../services/resourceService';
import { getFileIcon } from '../../utils/fileUtils';

function ResourceUpload({ show, onHide, onSuccess }) {
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        category: 'otros',
        accessible_by: 'all',
        file: null
    });
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({ ...formData, file });
            setError(null);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.file) {
            setError('Debes seleccionar un archivo');
            return;
        }

        setUploading(true);
        setError(null);

        const data = new FormData();
        data.append('title', formData.title);
        data.append('description', formData.description);
        data.append('category', formData.category);
        data.append('accessible_by', formData.accessible_by);
        data.append('file', formData.file);

        try {
            await resourceService.uploadResource(data);
            setFormData({ title: '', description: '', category: 'otros', accessible_by: 'all', file: null });
            onSuccess();
            onHide();
        } catch (err) {
            setError(err.response?.data?.error || 'Error al subir el archivo');
        } finally {
            setUploading(false);
        }
    };

    const { icon: FileIcon, color: iconColor } = formData.file ? getFileIcon(formData.file.name) : { icon: null, color: '' };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton className="bg-white border-bottom-0">
                <Modal.Title className="text-primary fw-bold">
                    <FaUpload className="me-2" />
                    Subir Nuevo Recurso
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body className="p-4">
                    {error && <Alert variant="danger">{error}</Alert>}

                    <Form.Group className="mb-3">
                        <Form.Label>Título *</Form.Label>
                        <Form.Control
                            type="text"
                            value={formData.title}
                            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                            required
                            placeholder="Ej: Tarifario Electricidad 2026"
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Categoría *</Form.Label>
                        <Form.Select
                            value={formData.category}
                            onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                            required
                        >
                            <option value="electricidad">Electricidad</option>
                            <option value="gas">Gas</option>
                            <option value="legal">Legal</option>
                            <option value="otros">Otros</option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Accesible por *</Form.Label>
                        <Form.Select
                            value={formData.accessible_by}
                            onChange={(e) => setFormData({ ...formData, accessible_by: e.target.value })}
                            required
                        >
                            <option value="all">Todos</option>
                            <option value="internal">Interno</option>
                            <option value="external">Externo</option>
                            <option value="call">Call</option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Descripción</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={formData.description}
                            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                            placeholder="Descripción opcional del recurso"
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Archivo *</Form.Label>
                        <Form.Control
                            type="file"
                            onChange={handleFileChange}
                            required
                        />
                        {formData.file && (
                            <div className={`mt-2 ${iconColor}`}>
                                <FileIcon className="me-2" />
                                {formData.file.name}
                            </div>
                        )}
                    </Form.Group>

                    {uploading && <ProgressBar animated now={100} label="Subiendo..." />}
                </Modal.Body>
                <Modal.Footer className="border-top-0">
                    <Button variant="secondary" onClick={onHide} disabled={uploading}>
                        Cancelar
                    </Button>
                    <Button variant="primary" type="submit" disabled={uploading}>
                        {uploading ? 'Subiendo...' : 'Subir Recurso'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ResourceUpload;
